import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import CommentList from "@/components/Comment/CommentList"
import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"
import { Button } from "@/components/common/Button"
import type { CommentParentTableType } from "@/graphql/codegen/graphql"
import { useCommentsActions } from "@/screens/Companies/hooks"

const CommentsSection: FC<{
  referenceId: string
  type: CommentParentTableType
  isReadOnly?: boolean
}> = ({ referenceId, type, isReadOnly = false }) => {
  const { commentList, commentListFetching, refetchCommentList } = useCommentsActions(referenceId, type)
  const [showAddComment, setShowAddComment] = useState<boolean>(false)

  const isDataMissing = !commentListFetching && !commentList.length && !showAddComment

  return isDataMissing ? (
    <InformationMissingAlert
      title={!isReadOnly ? "Start by adding comment(s)" : ""}
      description='No comments have been added yet. Once you add some, you will be able to see them here.'
      action={
        !isReadOnly && (
          <Button
            size='small'
            appearance='outlined'
            onClick={() => setShowAddComment(true)}
            data-testid='comments-add-button'
          >
            <AddOutlined />
            New Comment
          </Button>
        )
      }
    />
  ) : (
    <CommentList
      comments={commentList}
      referenceId={referenceId}
      commentType={type}
      isReadOnly={isReadOnly}
      showAddComment={showAddComment}
      setShowAddComment={setShowAddComment}
      onSuccess={() => refetchCommentList()}
    />
  )
}

export default CommentsSection
